module.exports = __webpack_public_path__ + "static/media/black-widow.e2ee6a43.png";